import { type ReactNode } from 'react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import Header from './Header';
import Footer from './Footer.tsx';
import { useLocation } from 'react-router-dom';

interface Props {
  children: ReactNode;
}

const Wrapper = (props: Props) => {
  const location = useLocation();

  return (
    <>
      <Header />
      <div className={`main ${location.pathname !== '/' ? 'container' : ''} mt-[54px] min-h-[calc(100vh_-_358px)] mx-auto`}>{props.children}</div>
      <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
      <Footer />
    </>
  );
};

export default Wrapper;
